import { Skeleton } from "@/app/components/ui/skeleton";
import { cn, generateImageUrlFromKey } from "@/lib/utils";
import { Flex, Text } from "@radix-ui/themes";
import Image from "next/image";
import React, { useEffect, useState } from "react";

interface Props {
  auctionId: number;
  lotId: number;
  message?: string | undefined;
  fallbackMessage?: string | undefined; // If no image is found, it will use this message
}
const LotLogInBanner = ({
  auctionId,
  lotId,
  fallbackMessage,
  message,
}: Props) => {
  const [imageURL, setImageURL] = useState<string | null | undefined>(null);

  useEffect(() => {
    const loadImage = async () => {
      fetch(
        `/api/image/auctions/${auctionId}/lots/${lotId}?limit=1`
      )
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw Error;
          }
        })
        .then((data) => {
          if (data?.[0]) setImageURL(generateImageUrlFromKey(data[0]));
          else throw Error;
        })
        .catch(() => setImageURL(undefined));
    };
    loadImage();
  }, [lotId, auctionId]);

  if (imageURL === null) {
    return (
      <Flex align="start" justify={"start"} className="w-full gap-8 -mt-4 mb-4">
        <Skeleton className="m-1 w-[150px] h-[100px] rounded-none cursor-default" />
        <Flex
          className="w-full"
          direction={"column"}
          align={"center"}
          justify={"center"}
        >
          <Skeleton className="m-1 w-full h-8" />
          <Skeleton className="m-1 w-full h-4" />
          <Skeleton className="m-1 w-full h-4" />
        </Flex>
      </Flex>
    );
  } else {
    return (
      <Flex
        justify="center"
        className={cn(
          "flex-col cursor-default items-center text-center gap-4 m-2",
          "md:text-start md:items-start md:gap-8 md:mb-6 md:flex-row md:relative",
          imageURL && "md:h-28",
          !!message || !!fallbackMessage && "mt-0"
        )}
      >
        {imageURL && (
          <Image
            src={imageURL}
            alt="Image Preview"
            height="100"
            width="100"
            style={{ display: "inline-block" }}
          />
        )}
        {(!!message || !!fallbackMessage) && (
          <Flex direction={"column"} className="gap-2">
            <Text className="font-medium text-black text-base">
              {imageURL ? message : fallbackMessage}
            </Text>
          </Flex>
        )}
      </Flex>
    );
  }
};

export default LotLogInBanner;
